import React, { useState, useEffect, useCallback } from "react";
import { FlexContainer, Img, Input, LabelText, SpanText, Hr, InputWrapper, Text } from "../../design";
import { Controller } from "react-hook-form";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { ErrorMessage } from "@hookform/error-message";
import debounce from "lodash.debounce";
import CvvIcon from "../../assets/imgs/cvv.svg";
import Luhn from "luhn";
import CreditCardType from "credit-card-type"
import { BrandLogo } from "../../helper";
import { CARD_NUMBER_LENGTH, ACCOUNT_MDR, VALID_YEAR_MONTH, COUNTRIES_LIST } from "../../appconstants";

const postalCodes = require('postal-codes-js');

type Props = {
  control: any,
  errors: any,
  charges: boolean,
  getPaymentCharges: Function,
  getPostalCodeChange: Function,
  callBackStatelist: Function,
  userType: String,
  alpha2: String,
  payments: Object,
  setValue: any,
  showWhatsAppNotify: Boolean,
  showPromoter: Boolean,
  isZipCodeRequired: boolean,
  isBillingAdressRequired: Boolean,
  billStatesList: Array,
  billStatesList2: Array,
  billStatesList2: Array,
  defaultCountry: Any,
  defaultCountry2: Any,
  callBackCountryCode: Function,
}

const Card = (props: Props) => {

  const DEFAULT_CARD_NUMBER_MASK = "#### #### #### #### ###";
  const { control, setValue, errors, showWhatsAppNotify, showPromoter, callBackCountryCode, defaultCountry, defaultCountry2, callBackStatelist, callBackStatelistShip, billStatesList, billStatesList2, charges, getPaymentCharges, getPostalCodeChange, getPostalCodeChange2, userType, payments, watch, isZipCodeRequired, isBillingAdressRequired, isShippingAddressRequired, clearErrors } = props;
  const [cardBrand, setCardBrand] = useState(null);
  const [cardNumberLengthMask, setCardNumberLengthMask] = useState(DEFAULT_CARD_NUMBER_MASK);
  const postalCode = 'Postal Code';
  const zipCode = 'Zip Code';
  const pincodeLabel = 'Postal Code';
  const [checked, setChecked] = useState(false);
  const [checkedShipping, setShippingChecked] = useState(false);
  const [promoterCheck, setPromoterCheck] = useState(true);
  const [countryNameCode2, setCountryNameCode2] = useState();

  //One School At A Time, Inc

  const accntGid = [
    'account-c0adbb4137dc4d6c9a9df98cb29bf401',
  ];

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  useEffect(() => {
    setValue('promoter', promoterCheck);
  }, [promoterCheck]);

  const isExpiryValidate = (data: string) => {
    const cardExpiry = data && data.split(" / ");
    const today = new Date(); const expireDay = new Date();
    const findYear = parseInt(cardExpiry[1]);
    const charYear = findYear.toString();
    const count = charYear.length;
    let year;
    if (count === 2) {
      year = parseInt(cardExpiry[1]) + VALID_YEAR_MONTH.ADDINGYEARS;
    } else {
      year = parseInt(cardExpiry[1]);
    }
    expireDay.setFullYear(parseInt(year), parseInt(cardExpiry[0]), 1);
    if (isEmpty(cardExpiry[1]) || isEmpty(cardExpiry[0]) ||
      parseInt(cardExpiry[0]) > VALID_YEAR_MONTH.TOTALMONTHS || parseInt(year) > VALID_YEAR_MONTH.MAXYEAR || expireDay < today) {
      return "Please enter a valid card expiration date";
    }
  };

  const isZipcodeValidate = (data: string) => {
    const cuntryCode = watch().country;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isZipcodeValidate1 = (data: string) => {
    const cuntryCode = watch().country;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isZipcodeValidateShip = (data: string) => {
    const cuntryCode = accntGid.includes(payments?.account?.gid) ? "US" : watch().shipcountry;
    if (postalCodes.validate(cuntryCode, data) !== true) {
      return postalCodes.validate(cuntryCode, data)
    }
  };

  const isEmpty = data => {
    return data && /^\s*$/.test(data);
  };

  const isCardValidate = (data: string) => {
    let number = data && data.replace(/\s+/g, '');
    const cardDetails = CreditCardType(number);
    let cardNumberLengths = [11, 12, 13, 14, 15, 16, 17, 18, 19];
    if (cardDetails.length > 0) {
      const card = cardDetails && cardDetails[0];
      cardNumberLengths = card && card.lengths;
    }
    if (!number || !cardNumberLengths.includes(number.length) || !Luhn.validate(number)) {
      return "Invalid card number";
    }
  };

  const validCard = (data: string) => {
    let number = data && data.replace(/\s+/g, '');
    const cardDetails = CreditCardType(number);
    let cardNumberLengths = [11, 12, 13, 14, 15, 16, 17, 18, 19];
    if (cardDetails.length > 0 && cardNumberLengths.includes(number.length)) {
      const card = cardDetails && cardDetails[0];
      cardNumberLengths = card && card.lengths;
      return true;
    }
    if (!number || !cardNumberLengths.includes(number.length) || !Luhn.validate(number)) {
      return false;
    }
  };

  const setCardBrandIcon = (data: string) => {
    const { value } = data;
    const cardDetails = CreditCardType(value);
    let cardBrand = null;
    if (cardDetails.length > 0) {
      const card = cardDetails && cardDetails[0];
      const { type } = card;
      cardBrand = value ? type : null;
    }
    setCardNumberLengthMask(DEFAULT_CARD_NUMBER_MASK);
    if (cardBrand && CARD_NUMBER_LENGTH[cardBrand]) {
      setCardNumberLengthMask(maskStrGenarator(CARD_NUMBER_LENGTH[cardBrand]));
    }
    setCardBrand(cardBrand);
  };

  const maskStrGenarator = (length: number) => {
    let output = "";
    for (let i = 0; i < length; i++) {
      if (i > 0 && i % 4 === 0) {
        output += " "
      }
      output += "#";
    }
    return output;
  };

  const debounceGetPaymentCharges = useCallback(
    debounce((searchVal, payments) => {
      getPaymentCharges(searchVal, payments);
    }, 2000),
    []
  );

  const getCharges = (e) => {
    const { value } = e;
    if (validCard(value && value.replace(/ /g, "")) && charges && userType !== ACCOUNT_MDR.MERCHANT) {
      debounceGetPaymentCharges(value, payments);
    }
  };

  const debounceGetPostalCodeChange = useCallback(
    debounce((searchVal) => {
      getPostalCodeChange(searchVal);
    }, 500),
    []
  );

  const debounceGetPostalCodeChange2 = useCallback(
    debounce((searchVal) => {
      getPostalCodeChange2(searchVal);
    }, 500),
    []
  );

  const getCountryCode = (value) => {
    debounceGetPostalCodeChange(value);
  };

  const getCountryCode2 = (value) => {
    debounceGetPostalCodeChange2(value);
  };

  const getStatelist = (value) => {
    callBackStatelist(value);
  }

  const getStatelistShip = (value) => {
    callBackStatelistShip(value);
  }

  const customStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      marginTop: "8px",
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),


  };

  const handleShipAddressChangeStateShip = (selectedOption, value1, value) => {
    setValue(value, selectedOption);
  };

  const handleShipAddressChangeState = (selectedOption, value1, value) => {
    if (checkedShipping && value1 === "billstate") {
      setValue(value, selectedOption?.value);
      setValue(value1, selectedOption?.value);
    } else if (checkedShipping && value1 === "country") {
      setValue(value1, selectedOption?.value);
      setValue(value, selectedOption?.value);
      setValue("billstate", "");
      setValue("shipstate", "");
    } else {
      setValue(value1, selectedOption?.value);
    };
  };


  const setBillingToShipping = (target) => {
    setShippingChecked(target.checked);
    const { billstate, country, billaddress, billaddress1, billcity, zipCode } = watch();
    setValue("shipstate", billstate);
    setValue("shipcountry", country);
    setValue("shipaddress", billaddress);
    setValue("shipaddress1", billaddress1);
    setValue("shipcity", billcity);
    setValue("shipzipCode", zipCode);
  }

  const handleShipAddressChange = (e, caseType, shipValue) => {
    if (checkedShipping) {
      setValue(caseType, e);
      setValue(shipValue, e);
    } else {
      setValue(caseType, e);
    }
  };

  const stateOptions = billStatesList?.map((item) => {
    return { label: item?.name, value: item?.isoCode }
  });

  const shipStateOptions = billStatesList2?.map((item) => {
    return { label: item?.name, value: item?.isoCode }
  });

  const countryOptions = COUNTRIES_LIST?.map((item) => {
    return { label: item?.name, value: item?.code }
  });

  return (
    <>
      <LabelText>
        Card Information
      </LabelText>
      <InputWrapper marginTop="8px" width='299px' borderDown="none !important" paddingRight='5px' borderRadius="4px 4px 0px 0px">
        <Controller
          defaultValue={''}
          border="0px !important"
          marginBottom="0px"
          marginTop="0px"
          marginLeft="5px"
          borderDown="none"
          control={control}
          name="card"
          color={errors.card ? "red" : "inherit"}
          rules={{
            required: "Card number is required",
            validate: isCardValidate
          }}
          as={<NumberFormat style={{
            marginLeft: '0',
            marginBottom: "0",
            width: "268px",
            borderRadius: "4px 4px 0px 0px",
          }}
            onValueChange={values => {
              setCardBrandIcon(values);
              getCharges(values);
            }}
            placeholder="Enter your card number"
          />}
          customInput={Input}
          format={cardNumberLengthMask}
          mask=""
        />
        {BrandLogo(cardBrand)}
      </InputWrapper>
      <FlexContainer>
        <Controller
          defaultValue={''}
          {...props}
          control={control}
          name="expiry"
          color={errors.expiry ? "red" : "inherit"}
          rules={{
            required: "Expiry is required",
            validate: isExpiryValidate
          }}
          as={<NumberFormat
            style={
              {
                marginTop: "0",
                marginBottom: "0px",
                width: "150px",
                borderRadius: "0px 0px 0px 4px",
                borderRight: "none",
              }
            }
            placeholder="MM / YYYY"
          />}
          customInput={Input}
          format="## / ####"
        />
        <InputWrapper paddingLeft='5px' marginBottom="0px" paddingRight='5px' borderRadius="0px 0px 4px 0px">
          <Controller
            defaultValue={''}
            border="0px !important"
            marginBottom="0px"
            marginTop="0px"
            marginLeft="5px"
            width='0px'
            control={control}
            name="cvv"
            color={errors.cvv ? "red" : "inherit"}
            rules={{
              required: 'CVC is required',
              pattern: {
                value: /\d{3,4}/,
                message: 'Invalid CVC number',
              },
            }}
            as={<NumberFormat
              style={{
                marginTop: "0",
                marginBottom: "0px",
                width: "108px",
                borderRadius: "0px 0px 4px 0px",
              }}
              placeholder="CVC"
            />}
            customInput={Input}
            format="####"
            mask=""
            type="password"
          />
          <Img verticalAlign='middle' src={CvvIcon} />
        </InputWrapper>
      </FlexContainer>
      <ErrorMessage
        errors={errors}
        name="card"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <ErrorMessage
        errors={errors}
        name="expiry"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <ErrorMessage
        errors={errors}
        name="cvv"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      <LabelText>
        Name on Card
      </LabelText>
      <Controller
        defaultValue={''}
        marginBottom="0px"
        control={control}
        name="name"
        placeholder="Enter cardholder name"
        color={errors.name ? "red" : "inherit"}
        rules={{
          required: 'Cardholder name is required',
          pattern: {
            value: /^[a-zA-Z ]*$/,
            message: 'Name can only contain alpha characters and spaces.',
          }
        }}
        as={Input}
      />
      <ErrorMessage
        errors={errors}
        name="name"
        render={({ message }) => (
          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        )}
      />
      {
        isBillingAdressRequired ? (
          <>
            <Hr />
            {
              <>
                {defaultCountry && (
                  <div>
                    <>
                      <LabelText className="mb-2">
                        Billing Address
                      </LabelText>
                      <Controller
                        color={errors.billaddress ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="billaddress"
                        placeholder="Address"
                        rules={{
                          required: 'Address is required',
                        }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            defaultValue={watch()?.billaddress || ""}
                            placeholder="Address"
                            onChange={(e) => {
                              clearErrors("billaddress");
                              handleShipAddressChange(e.target.value, "billaddress", "shipaddress"); // Your custom logic
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="billaddress"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <Controller
                        defaultValue={""}
                        color={errors.billaddress1 ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="billaddress1"
                        placeholder="Address2"
                        render={({ field }) => (
                          <Input
                            {...field}
                            defaultValue={""}
                            placeholder="Address"
                            onChange={(e) => {
                              clearErrors("billaddress1");
                              handleShipAddressChange(e.target.value, 'billaddress1', 'shipaddress1'); // Your custom logic
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="billaddress1"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <Controller
                        defaultValue={""}
                        color={errors.billcity ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="billcity"
                        placeholder="City"
                        rules={{
                          required: 'City is required',
                        }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            defaultValue={watch()?.billcity || ""}
                            placeholder="City"
                            onChange={(e) => {
                              clearErrors("billcity");
                              handleShipAddressChange(e.target.value, 'billcity', 'shipcity'); // Your custom logic
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="billcity"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <div style={{
                        width: "299px"
                      }}>
                        <Controller
                          control={control}
                          name="billstate"
                          rules={{ required: "State is required" }}
                          render={({ field }) => {
                            return (
                              <Select
                                {...field}
                                theme={(theme) => ({
                                  ...theme,
                                  borderRadius: "4px",
                                  boxShadow: 0,
                                })}
                                menuPlacement="auto"
                                styles={customStyles}
                                options={stateOptions}
                                value={stateOptions?.find((option) => option?.value === watch()?.billstate) || ""}
                                onChange={(selectedOption) => {
                                  clearErrors("billstate");
                                  handleShipAddressChangeState(selectedOption, "billstate", "shipstate");
                                }}
                              />
                            );
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="billstate"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                        <LabelText />
                        <Controller
                          marginTop="8px !important"
                          marginBottom="0px"
                          defaultValue={""}
                          color={errors.zipCode ? "red" : "inherit"}
                          control={control}
                          name="zipCode"
                          isSearchable="true"
                          placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel}
                          rules={{
                            required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                            validate: isZipcodeValidate1
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              style={{
                                marginTop: "0px",
                                marginBottom: "0px",
                                width: "299px",
                                borderRadius: "0px 0px 4px 4px",
                              }}
                              defaultValue={(accntGid.includes(payments?.account?.gid) ? "" : watch()?.zipCode) || ""}
                              type="text"
                              placeholder="Zip Code"
                              onChange={(e) => {
                                clearErrors("zipCode");
                                handleShipAddressChange(e.target.value, 'zipCode', 'shipzipCode');
                              }}
                            />
                          )}
                          customInput={Input}
                        />

                        <ErrorMessage
                          errors={errors}
                          name="zipCode"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />

                      </div>
                      <div style={{
                        width: "299px",
                        marginTop: "16px"
                      }}>
                        <Controller
                          color={errors.country ? "red" : "inherit"}
                          marginBottom="0px"
                          control={control}
                          name="country"
                          placeholder="Select a country"
                          rules={{
                            required: 'Shipping Country is required'
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              className="px-0 border-0"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: '4px',
                                boxShadow: 0,
                              })}
                              styles={customStyles}
                              options={countryOptions}
                              menuPlacement="auto"
                              readOnly={accntGid.includes(payments?.account?.gid)}
                              value={(accntGid.includes(payments?.account?.gid) ? countryOptions?.find((item) => item?.value === "US") : countryOptions?.find((item) => item?.value === watch().country)) || ""}
                              placeholder="Country"
                              onChange={(event) => {
                                //getStatelistShip(event);
                                //setCountryNameCode2(event.code);
                                handleShipAddressChangeState(event, 'country', 'shipcountry')
                                callBackCountryCode(event.value);
                                getStatelist(event?.value);
                                //setCountryNameCode(event.value);
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="country"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </div>
                    </>
                  </div>
                )}

                <Hr />
              </>
            }
          </>
        ) : (isZipCodeRequired && (!isBillingAdressRequired)) ? (
          <>

            <LabelText>
              Country
            </LabelText>
            <div style={{
              width: "299px"
            }}>
              <Controller
                color={errors.country ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="country"
                placeholder="Select a country"
                rules={{
                  required: 'Country is required'
                }}
                // as={<Select
                //   className="px-0 border-0"
                //   theme={theme => ({
                //     ...theme,
                //     borderRadius: "4px",
                //     boxShadow: 0,
                //   })}
                //   defaultValue={''}
                //   getOptionLabel={(option) => option.name}
                //   getOptionValue={(option) => option.code}
                //   styles={customStyles}
                //   options={COUNTRIES_LIST} />}
                render={({ field }) => (
                  <Select
                    {...field}
                    className="px-0 border-0"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '4px',
                      boxShadow: 0,
                    })}
                    styles={customStyles}
                    options={countryOptions}
                    menuPlacement="auto"
                    readOnly={accntGid.includes(payments?.account?.gid)}
                    value={(accntGid.includes(payments?.account?.gid) ? countryOptions?.find((item) => item?.value === "US") : countryOptions?.find((item) => item?.value === watch().country)) || ""}
                    placeholder="Country"
                    onChange={(event) => {
                      //getStatelistShip(event);
                      //setCountryNameCode2(event.code);
                      handleShipAddressChangeState(event, 'country', 'shipcountry')
                      callBackCountryCode(event.value);
                      getStatelist(event?.value);
                      //setCountryNameCode(event.value);
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="country"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </div>
            <LabelText>
              {(defaultCountry && defaultCountry.code === "US") ? "Zip Code" : "Postal Code"}
            </LabelText>
            <Controller
              marginTop="8px !important"
              marginBottom="0px"
              defaultValue={""}
              color={errors.zipCode ? "red" : "inherit"}
              control={control}
              name="zipCode"
              isSearchable="true"
              placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : postalCode}
              rules={{
                required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                validate: isZipcodeValidate
              }}
              as={<Input style={{
                marginTop: "0px",
                marginBottom: "0px",
                width: "299px",
                borderRadius: "0px 0px 4px 4px",
              }}
                type="text"
                name="zipCode"
                onInput={event => {
                  getCountryCode(event.target.value);
                }}
                placeholder="Zip Code"
              />}
              customInput={Input}
            />
            <ErrorMessage
              errors={errors}
              name="zipCode"
              render={({ message }) => (
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
              )}
            />
          </>
        ) : ''
      }

      {
        isShippingAddressRequired ? (
          <>

            {
              <>

                {defaultCountry2 && (
                  <div>
                    <div className="mt-2">
                      {isBillingAdressRequired ? (
                        <label>
                          <Controller
                            marginBottom="0px" name='shppingAddress' control={control} as={<Input type="checkbox"
                              defaultChecked={checkedShipping}
                              onClick={({ target }) => setBillingToShipping(target)} width="auto" />} />
                          <SpanText className="pl-2">Use Billing Address For Shipping </SpanText></label>
                      ) : ""}
                    </div>
                    <>

                      <LabelText className="mb-2">
                        Shipping Address
                      </LabelText>
                      <Controller
                        defaultValue={''}
                        color={errors.shipaddress ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name='shipaddress'
                        placeholder="Address"
                        rules={{
                          required: 'Address is required',
                        }}
                        as={Input}
                        /*render={({ field }) => (
                          <Input

                            onChange={(e) => {

                             handleShipAddressChange(e.target.value,'billaddress','shipaddress');
                            }}
                            placeholder="Address"
                          />
                        )}*/

                        className={checkedShipping ? 'disabled' : ''}
                        disabled={checkedShipping}


                      />
                      <style jsx>{`
        .disabled {
          
          background-color: #f2f2f2;
          color: #888;
          cursor: not-allowed;
        }
      `}</style>
                      <ErrorMessage
                        errors={errors}
                        name="shipaddress"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <Controller
                        defaultValue={""}
                        color={errors.shipaddress1 ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="shipaddress1"
                        placeholder="Address"
                        as={Input}
                        /* render={({ field }) => (
                           <Input
 
                             onChange={(e) => {
 
                              handleShipAddressChangeShip(e.target.value,'billaddress','shipaddress1');
                             }}
                             placeholder="Address"
                           />
                         )}*/
                        disabled={checkedShipping}
                        className={checkedShipping ? 'disabled' : ''}
                      />
                      <style jsx>{`
        .disabled {
          
          background-color: #f2f2f2;
          color: #888;
          cursor: not-allowed;
        }
      `}</style>
                      <ErrorMessage
                        errors={errors}
                        name="shipaddress1"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <Controller
                        defaultValue={""}
                        color={errors.shipcity ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="shipcity"
                        placeholder="City"
                        rules={{
                          required: 'City is required',
                        }}
                        as={Input}
                        disabled={checkedShipping}
                        className={checkedShipping ? 'disabled' : ''}
                      />
                      <style jsx>{`
        .disabled {
          
          background-color: #f2f2f2;
          color: #888;
          cursor: not-allowed;
        }
      `}</style>
                      <ErrorMessage
                        errors={errors}
                        name="shipcity"
                        render={({ message }) => (
                          <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                      />
                      <LabelText />
                      <div style={{
                        width: "299px"
                      }}>
                        <Controller
                          disabled={checkedShipping}
                          defaultValue={""}
                          color={errors.shipstate ? "red" : "inherit"}
                          marginBottom="0px"
                          marginTop="8px"
                          border="0px !important"
                          control={control}
                          name="shipstate"
                          placeholder="State"
                          rules={{
                            required: 'Ship State is required'
                          }}

                          render={({ field }) => (
                            <Select
                              {...field}
                              theme={theme => ({
                                ...theme,
                                borderRadius: "4px",
                                boxShadow: 0,
                              })}
                              menuPlacement="auto"
                              styles={customStyles}
                              options={shipStateOptions}
                              isDisabled={checkedShipping}
                              value={stateOptions?.find((option) => option?.value === watch()?.shipstate) || ""}
                              onChange={(option) => setValue('shipstate', option?.value)} // Properly pass the event handler
                            />
                          )}

                        // as={<Select
                        //   theme={theme => ({
                        //     ...theme,
                        //     borderRadius: "4px",
                        //     boxShadow: 0,
                        //   })}
                        //   // menuIsOpen={true}
                        //   menuPlacement="auto"
                        //   styles={customStyles}
                        //   getOptionLabel={(option) => option.name}
                        //   getOptionValue={(option) => option.isoCode}
                        //   options={billStatesList2}
                        //   isDisabled={checkedShipping}
                        // />
                        //}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="shipstate"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                        <LabelText />
                        <Controller
                          marginTop="8px !important"
                          marginBottom="0px"
                          //defaultValue={defaultzipcode}
                          color={errors.shipzipCode ? "red" : "inherit"}
                          control={control}
                          name="shipzipCode"
                          isSearchable="true"
                          placeholder={(defaultCountry && defaultCountry.code === "US") ? zipCode : postalCode}
                          rules={{
                            required: `${(defaultCountry && defaultCountry.code === "US") ? zipCode : pincodeLabel} is required`,
                            validate: isZipcodeValidateShip
                          }}
                          as={<Input style={{
                            marginTop: "0px",
                            marginBottom: "0px",
                            width: "299px",
                            borderRadius: "0px 0px 4px 4px",
                          }}
                            type="text"
                            className={checkedShipping ? 'disabled' : ''}
                            disabled={checkedShipping}
                            // onInput={event => {
                            // getCountryCode(event.target.value);
                            //}}
                            // className={checkedShipping ? 'disabled' : ''}
                            onInput={
                              (e) => handleShipAddressChangeStateShip(e.target.value, 'zipCode', 'shipzipCode')
                            }
                            placeholder="Zip Code"
                          />}
                          customInput={Input}
                        />


                        <style jsx>{`
        .disabled {
          
          background-color: #f2f2f2;
          color: #888;
          cursor: not-allowed;
        }
      `}</style>

                        <ErrorMessage
                          errors={errors}
                          name="shipzipCode"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </div>
                      <div style={{
                        width: "299px",
                        marginTop: "16px"
                      }}>
                        <Controller
                          color={errors.shipcountry ? "red" : "inherit"}
                          marginBottom="0px"
                          control={control}
                          name="shipcountry"
                          placeholder="Select a country"
                          rules={{
                            required: 'Country is required'
                          }}
                          render={({ field }) => (
                            <Select
                              isDisabled={checkedShipping}
                              {...field}
                              className="px-0 border-0"
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: '4px',
                                boxShadow: 0,
                              })}
                              // getOptionLabel={(option) => option.name}
                              // getOptionValue={(option) => option.code}
                              styles={customStyles}
                              options={countryOptions}
                              value={(accntGid.includes(payments?.account?.gid) ? countryOptions?.find((item) => item?.value === "US") : countryOptions?.find((item) => item?.value === watch().shipcountry)) || ""}
                              placeholder="Country"
                              readOnly={accntGid.includes(payments?.account?.gid)}
                              onChange={(event) => {
                                setValue('shipcountry', event?.value)
                                setValue('shipstate', '')
                                getStatelistShip(event?.value);
                                setCountryNameCode2(event?.value);
                                callBackCountryCode(event?.value);
                              }}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="shipcountry"
                          render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                          )}
                        />
                      </div>
                    </>
                  </div>

                )}

                <Hr />
              </>
            }
          </>
        ) : "" //</>(isZipCodeRequired && (!isBillingAdressRequired)) ? (
        //  <! <>
        //     <LabelText>
        //       Country3
        //     </LabelText>
        //     <div style={{
        //       width: "299px"
        //     }}>
        //       <Controller
        //       disabled={checkedShipping}
        //         defaultValue={''}
        //         color={errors.country ? "red" : "inherit"}
        //         marginBottom="0px"
        //         control={control}
        //         name="country"
        //         placeholder="Select a country"
        //         rules={{
        //           required: 'Shipping Country is required'
        //         }}
        //         as={<Select
        //           className="px-0 border-0"
        //           theme={theme => ({
        //             ...theme,
        //             borderRadius: "4px",
        //             boxShadow: 0,
        //           })}
        //           defaultValue={''}
        //           getOptionLabel={(option) => option.name}
        //           getOptionValue={(option) => option.code}
        //           styles={customStyles}
        //           options={COUNTRIES_LIST} />}
        //       />
        //       <ErrorMessage
        //         errors={errors}
        //         name="country"
        //         render={({ message }) => (
        //           <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        //         )}
        //       />
        //     </div>
        //     <LabelText>
        //       Postal Code
        //     </LabelText>
        //     <Controller
        //     disabled={checkedShipping}
        //       marginTop="8px !important"
        //       marginBottom="0px"
        //       defaultValue={""}
        //       color={errors.zipCode ? "red" : "inherit"}
        //       control={control}
        //       name="zipCode"
        //       isSearchable="true"
        //       placeholder={postalCode}
        //       rules={{
        //         required: `${pincodeLabel} is required`,
        //         validate: isZipcodeValidateShip
        //       }}
        //       as={<Input style={{
        //         marginTop: "0px",
        //         marginBottom: "0px",
        //         width: "299px",
        //         borderRadius: "0px 0px 4px 4px",
        //       }}
        //         type="text"
        //         name="shipzipCode"
        //         onInput={event => {
        //           getCountryCode2(event.target.value);
        //         }}
        //         placeholder="Enter your card number"
        //       />}
        //       customInput={Input}
        //     />
        //     <ErrorMessage
        //       errors={errors}
        //       name="shipzipCode"
        //       render={({ message }) => (
        //         <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
        //       )} 
        //     />
        //   </>
        // ) : ''
      }
      {
        showWhatsAppNotify && (
          <div className="mt-3">
            <label>
              <Controller
                marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                  defaultChecked={checked}
                  onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
              <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
          </div>
        )
      }
      {
        showPromoter && (
          <div className="mt-3">
            <label>
              <Controller
                marginBottom="0px" name='promoter' control={control} as={<Input type="checkbox"
                  defaultChecked={promoterCheck}
                  onClick={({ target }) => setPromoterCheck(target.checked)} width="auto" />} />
              <SpanText className="pl-2">Get offers on money transfers to India with ICICI Bank Money2India</SpanText></label>
          </div>
        )
      }
    </>
  )
};

export default Card;
